import styled from 'styled-components';
import { ColumnDiv } from 'styles/elements/div';
import { Select } from 'styles/elements/select';
import media from 'styles/media';

const AddressLookup = styled(ColumnDiv)`
  align-items: flex-start;
`;

const SelectContainer = styled(ColumnDiv)`
  background-color: ${props => props.theme.brandingPrimaryShadeEight};
  padding: 20px;
  width: 55%;
  box-sizing: border-box;
  margin: 0;
  ${media.smallAndBelow`
    width: 100%;
  `};
`;

AddressLookup.SelectContainer = SelectContainer;
AddressLookup.Select = Select;
AddressLookup.Option = styled.option``;

export default AddressLookup;
